import React from "react"
import * as styles from "./spinner.module.scss"

export default () => {
  return (
    <div className={styles.ldsSpinner}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  )
}